import { render, staticRenderFns } from "./RevenuesDetailsIndicator.vue?vue&type=template&id=74af5346&scoped=true"
import script from "./RevenuesDetailsIndicator.vue?vue&type=script&lang=js"
export * from "./RevenuesDetailsIndicator.vue?vue&type=script&lang=js"
import style0 from "./RevenuesDetailsIndicator.vue?vue&type=style&index=0&id=74af5346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74af5346",
  null
  
)

export default component.exports